<template>
  <div>
    <template v-if="ad">
      <div class="container ad-container" v-if="hasContainer">
        <a
          :key="ad.url"
          :href="ad.url"
          :title="ad.message"
          target="_blank"
          :class="adClass"
        >
          <img
            :src="ad.image.url"
            :alt="ad.message"
          >
        </a>
      </div>
      <a
        v-else
        :key="ad.url"
        :href="ad.url"
        :title="ad.message"
        target="_blank"
        :class="adClass"
      >
        <img
          :src="ad.image.url"
          :alt="ad.message"
        >
      </a>
    </template>
    <template v-else>
      <template v-if="hasContainer">
        <div class="container ad-container" v-if="adverts.length > 0">
          <a
            v-for="ad in adverts"
            :key="ad.url"
            :href="ad.url"
            :title="ad.message"
            target="_blank"
            :class="adClass"
          >
            <img
              :src="ad.imageUrl"
              :alt="ad.message"
            >
          </a>
        </div>
        <div class="container ad-container" v-else>
          <GoogleAdvertComponent size="fixed" />
        </div>
      </template>
      <template v-else>
        <a
          v-for="ad in adverts"
          :key="ad.url"
          :href="ad.url"
          :title="ad.message"
          target="_blank"
          :class="adClass"
        >
          <img
            :src="ad.imageUrl"
            :alt="ad.message"
          >
        </a>
      </template>
    </template>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import GoogleAdvertComponent from '../advert/GoogleAdvertComponent.vue';

export default {
  name: 'AdvertComponent',
  components: {
    GoogleAdvertComponent,
  },
  apollo: {
    adverts: {
      query: gql`query advertQuery($country: String!, $slot: String!) {
        adverts(country: $country, slot: $slot) {
          message,
          imageUrl,
          url
        }
      }`,
      variables() {
        return {
          country: this.country,
          slot: this.adSlot,
          cache:this.cache
        };
      },
    },
  },
  props: {
    country: {
      type: String,
      default: 'SG',
    },
    advert: {
      type: Object,
      default: () => ({}),
    },
    adSlot: {
      type: String,
      default: 'site_leaderboard',
    },
    hasContainer: {
      type: Boolean,
      default: true,
    },
    cache: {
      type: Object,
      default: () => ({
        cache: true,
        component: 'advert'
      })
    }
  },
  data() {
    return {
      adverts: [],
    };
  },
  computed: {
    ad() {
      if (this.advert !== null && this.advert.slot === this.adSlot) {
        // for previews
        return this.advert;
      }
      return null;
    },
    adClass() {
      return `ad ad--placement-${this.adSlot.replace(/_/g, '-')}`;
    },
  },
};
</script>
